const Divider = ({title }) => {
    return (
        <div class="main-content__divider">
            <div class="main-content__divider-title">{title}</div>
        </div>
    );
};

export default Divider;
